import React from 'react'
import "./SafetyInfractions.css"
// import cblogo from "../../images/cb-logo.svg"
import infocap from "../../images/info1.svg"
import mtype from "../../images/ct1.svg"
import lz from "../../images/location1.svg"
import user from "../../images/wrp1.svg"
import timeline from "../../images/sm2.svg"
import IncidentDetails from './IncidentDetails'

function SafetyInfractions() {
    const alertData = [
     

    {
        name: 'Missing Helmet',
        id: 1,
        image: 'alert_icon.svg',
        capture_image:'Missing Helmet1.png',
        capture_video:'Missing Safety Helmet1.mp4',
        cp_image:'sm-cp-img.png',
        loc: { x: '74', y: '196' },
        label: 'Tower 3, Zone 1',
        operator: 'Karen Chilton',
        work_type:'Blasting',
        alert_type_level:'Safety Infraction | Severity Level - 2 | Cam#DID1',
        alert_date_time: '25-02-2025 | 07:00 AM',
        
    },
    {
        name: 'Missing Safety Vest',
        id: 2,
        image: 'alert_icon.svg',
        capture_image: 'Missing Safety Vest1.png',
        capture_video: 'Missing Safety Vest1.mp4',
        cp_image:'sm-cp-img.png',
        loc: { x: '-69', y: '275' },
        label: 'Mining Area, Zone 1',
        operator: 'Fed Chilton',
        work_type:'Inspection',
        alert_type_level:'Human Infraction | Severity Level - 3 | Cam#DID2',
        alert_date_time: '25-02-2025 | 08:15 AM',
        

    },
    {
        name: 'Missing Safety Goggles',
        id: 3,
        image: 'alert_icon.svg',
        capture_image: 'Missing Safety Goggles1.png',
        capture_video: 'Missing Safety Goggles1.mp4',
        cp_image:'sm-cp-img.png',
        loc: { x: '-127', y: '374' },
        label: 'Tower 2, Zone 1',
        operator: 'Peter Bishop',
        work_type:'Blasting',
        alert_type_level:'Safety Infraction | Severity Level - 2 | Cam#DID3',
        alert_date_time: '25-02-2025 | 09:00 AM',
    },
    {
        name: 'Missing Helmet',
        id: 4,
        image: 'alert_icon.svg',
        capture_image:'Missing Helmet1.png',
        capture_video:'Missing Safety Helmet1.mp4',
        cp_image:'sm-cp-img.png',
        loc: { x: '74', y: '196' },
        label: 'Tower 3, Zone 1',
        operator: 'Peter Bishop',
        work_type:'Blasting',
        alert_type_level:'Safety Infraction | Severity Level - 2 | Cam#DID1',
        alert_date_time: '25-02-2025 | 07:00 AM',
        
    },
    {
        name: 'Missing Safety Shoes',
        id: 5,
        image: 'alert_icon.svg',
        capture_image: 'Missing Safety Shoes1.png',
        capture_video: 'Missing Safety Shoes1.mp4',
        cp_image:'sm-cp-img.png',
        loc: { x: '96', y: '481' },
        label: 'Tower 2, Zone 3',
        operator: 'Jack Fred',
        work_type:'Loading',
        alert_type_level:'Human Infraction | Severity Level - 3 | Cam#DID2',
        alert_date_time: '25-02-2025 | 09:25 PM',

    },
    {
        name: 'Missing Safety Gloves',
        id: 6,
        image: 'alert_icon.svg',
        capture_image:'Missing Safety Gloves1.png',
        capture_video:'Missing Safety Gloves1.mp4',
        cp_image:'sm-cp-img.png',
        loc: { x: '4', y: '513' },
        label: 'Tower 3, Zone 2',
        operator: 'Pannola Van',
        work_type:'Drilling',
        alert_type_level:'Safety Infraction | Severity Level - 2 | Cam#DID9',
        alert_date_time: '25-02-2025 | 08:00 PM',
    },
    
    {
        name: 'Missing Safety Vest',
        id: 7,
        image: 'alert_icon.svg',
        capture_image: 'Missing Safety Vest1.png',
        capture_video: 'Missing Safety Vest1.mp4',
        cp_image:'sm-cp-img.png',
        loc: { x: '85', y: '275' },
        label: 'Mining Area, Zone 1',
        operator: 'John Nathan',
        work_type:'Inspection',
        alert_type_level:'Human Infraction | Severity Level - 3 | Cam#DID2',
        alert_date_time: '25-02-2025 | 08:15 AM',
        

    },
    {
        name: 'Missing Safety Shoes',
        id: 8,
        image: 'alert_icon.svg',
        capture_image: 'Missing Safety Shoes1.png',
        capture_video: 'Missing Safety Shoes1.mp4',
        cp_image:'sm-cp-img.png',
        loc: { x: '96', y: '581' },
        label: 'Tower 2, Zone 3',
        operator: 'Wesly Tim',
        work_type:'Loading',
        alert_type_level:'Human Infraction | Severity Level - 3 | Cam#DID2',
        alert_date_time: '25-02-2025 | 09:25 PM',

    },
];

    const [activeIncident, setActiveIncident] = React.useState();


    const [showIncidentDetail, setShowIncidentDetail] = React.useState(false);
    const handleInfoIconClick = (e) => {
        //todo
        setShowIncidentDetail(true);
    }
    const handleDetailCardClose = () => {
        setShowIncidentDetail(false);
    }

    return (<>
        {showIncidentDetail &&
            <IncidentDetails activeIncident={activeIncident} handleDetailCardClose={handleDetailCardClose} />}
        <div className='si-container'>
            {/*<div className='cb-sec'>*/}
            {/*    <p className='cb-para'><img src={cblogo} alt="" /> Here is the yesterday’s safety infractions </p>*/}
            {/*</div>*/}
            <div className="dc-wrapper">
                {alertData.map((alert, key) => <div className="si-sec-1" key={key}>
                    <div className="si-details-wrapper">
                        <div className='si-det-1'>
                            <div className="si-head">
                                <p className='w-name'>{alert.name}</p>
                            </div>
                            <div className="si-info-logo">
                                <img src={infocap} alt="" className="pointer"
                                    onClick={(e) => {
                                        setActiveIncident(alert);
                                        handleInfoIconClick(e)
                                }} />
                            </div>
                            
                        </div>
                        <div className='si-det-2'>
                            <p className='w-id'> {alert.alert_type_level} </p>
                        </div>

                        <div className='si-det-3'>
                            <div className="w1"><p className='work-a'><img src={user} alt="" /> {alert.operator} </p></div>
                            <div className="w2"><p className='work-a'><img src={mtype} alt="" /> {alert.work_type.substring(0, 20)} </p></div>
                            

                        </div>
                        <div className='si-det-4'>
                            <div className="w1"><p className='work-a'><img src={lz} alt="" /> {alert.label.substring(0, 20)} </p></div>
                            <div className="w2"><p className='work-a'><img src={timeline} alt="" /> {alert.alert_date_time} </p></div>
                            
                        </div>
                    </div>
                </div>)}
            </div>
        </div>
    </>)
}

export default SafetyInfractions
